import { render, staticRenderFns } from "./FundsJournalTable.vue?vue&type=template&id=0b1bea5b&"
import script from "./FundsJournalTable.vue?vue&type=script&lang=js&"
export * from "./FundsJournalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports